import React from 'react';
import { Link } from 'react-router-dom';
import CreditsDisplay from './CreditsDisplay';
import './Sidebar.css';

interface SidebarProps {
  isOpen: boolean;
  onToggle: () => void;
  onLogout: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onToggle, onLogout }) => {

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && <div className="sidebar-overlay" onClick={onToggle} />}

      <button className={`hamburger-button ${isOpen ? 'is-open' : ''}`} onClick={onToggle}>
        <div className={`hamburger-icon ${isOpen ? 'open' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="sidebar-content">
          <div className="sidebar-header">
            <h3 className="sidebar-title">SoundLegal.ai</h3>
            <p className="sidebar-subtitle">Open Beta</p>
          </div>

          {/* Credits Display */}
          <CreditsDisplay variant="sidebar" onClick={onToggle} />

          <nav className="sidebar-nav">
            <ul className="nav-list">
              <li className="nav-item">
                <Link to="/" className="nav-link" onClick={onToggle}>
                  <span className="nav-icon">🏠</span>
                  <span className="nav-text">Home</span>
                </Link>
            </li>
              <li className="nav-item">
                <Link to="/interpreter" className="nav-link" onClick={onToggle}>
                  <span className="nav-icon">🔍</span>
                  <span className="nav-text">Document Analyzer</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/dashboard" className="nav-link" onClick={onToggle}>
                  <span className="nav-icon">📊</span>
                  <span className="nav-text">Analysis History</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contract-generator" className="nav-link" onClick={onToggle}>
                  <span className="nav-icon">📝</span>
                  <span className="nav-text">Contract Generator</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contract-generations" className="nav-link" onClick={onToggle}>
                  <span className="nav-icon">📄</span>
                  <span className="nav-text">Contract History</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/dictionary" className="nav-link" onClick={onToggle}>
                  <span className="nav-icon">📚</span>
                  <span className="nav-text">Dictionary</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/buy-credits" className="nav-link" onClick={onToggle}>
                  <span className="nav-icon">💳</span>
                  <span className="nav-text">Buy Credits</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/account-settings" className="nav-link" onClick={onToggle}>
                  <span className="nav-icon">⚙️</span>
                  <span className="nav-text">Account Settings</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/legal" className="nav-link" onClick={onToggle}>
                  <span className="nav-icon">📋</span>
                  <span className="nav-text">Legal Notices</span>
                </Link>
              </li>
            </ul>
          </nav>

          <div className="sidebar-footer">
            <button className="logout-button" onClick={onLogout}>
              <span className="nav-icon">🚪</span>
              <span className="nav-text">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar; 